export const HELP_AND_SUPPORT_OPTIONS_TEST_ID = 'HelpAndSupportOptions';
export const MISSING_ITEM_ROW_TEST_ID = 'MissingItemRow';
export const DELIVERY_ISSUES_ROW_TEST_ID = 'DeliveryIssuesRow';
export const GET_HELP_ROW_TEST_ID = 'GetHelpRow';
